import { zCreateAgentForAdminEndpointInput } from '@/general/src/agent/routes/createAgentForAdmin/input.js'
import { agentPermissionsOptions, canManageAgents } from '@/general/src/auth/can.js'
import { getSubscriptionPlanData } from '@/general/src/subscription/utils.shared.js'
import { GeneralLayout } from '@/webapp/src/components/layout/GeneralLayout/index.js'
import { useAppContext } from '@/webapp/src/lib/ctx.js'
import { Checkboxesy, Radiobuttonsy, Textfieldy, useFormy } from '@/webapp/src/lib/formy.js'
import { withPageWrapper } from '@/webapp/src/lib/pageWrapper.js'
import { adminAgentEditRoute } from '@/webapp/src/lib/routes.js'
import { trpc } from '@/webapp/src/lib/trpc.js'
import { Block, Button, Buttons, FormItems, Segment } from '@/webapp/src/lib/uninty.components.js'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const AdminAgentNewPage = withPageWrapper({
  title: 'Новый агент',
  Layout: GeneralLayout,
  authorizedAdminsOnly: true,
  checkAccess: ({ ctx }) => canManageAgents(ctx.me.admin),
})(() => {
  const ctx = useAppContext()
  const navigate = useNavigate()
  const createAgentForAdmin = trpc.createAgentForAdmin.useMutation()
  const formy = useFormy({
    initialValues: {
      name: '',
      email: '',
      phone: '',
      organizationSn: '',
      referrerAgentSn: '',
      referralBonusShare: '0.1' as never as number,
      permissions: [],
      subscriptionPlan: 'free',
      paidSubscriptionPlanExpiresAfterDays: 30,
      temporaryRecognitionTokensCount:
        ctx.appConfig.agentSubscriptionPlanMap.free.temporaryRecognitionTokensCountPerPeriod,
      temporaryScenarioTokensCount: ctx.appConfig.agentSubscriptionPlanMap.free.temporaryScenarioTokensCountPerPeriod,
    },
    validationSchema: zCreateAgentForAdminEndpointInput,
    onSubmit: async ({ valuesInput }) => {
      const res = await createAgentForAdmin.mutateAsync({
        ...valuesInput,
      })
      navigate(adminAgentEditRoute.get({ agentSn: res.agent.sn }))
    },
    successMessage: 'Агент создан',
  })
  useEffect(() => {
    const subscriptionPlanData = getSubscriptionPlanData({
      agentSubscriptionPlanMap: ctx.appConfig.agentSubscriptionPlanMap,
      subscriptionPlan: formy.values.subscriptionPlan,
    })
    void formy.setFieldValue(
      'temporaryRecognitionTokensCount',
      subscriptionPlanData.temporaryRecognitionTokensCountPerPeriod
    )
    void formy.setFieldValue('temporaryScenarioTokensCount', subscriptionPlanData.temporaryScenarioTokensCountPerPeriod)
  }, [formy.values.subscriptionPlan])
  return (
    <Block fcnw>
      <Segment title="Новый агент" size="m">
        <FormItems as="form" {...formy.formProps}>
          <Textfieldy label="Номер организации" {...formy.getFieldProps('organizationSn')} />
          <Textfieldy label="Номер реферера" {...formy.getFieldProps('referrerAgentSn')} />
          <Textfieldy label="Доля реферальной программы" {...formy.getFieldProps('referralBonusShare')} />
          <Textfieldy label="Имя" {...formy.getFieldProps('name')} />
          <Textfieldy label="Телефон" {...formy.getFieldProps('phone')} />
          <Textfieldy label="Почта" {...formy.getFieldProps('email')} />
          <Checkboxesy label="Права" options={agentPermissionsOptions} {...formy.getFieldProps('permissions')} />
          <Radiobuttonsy
            {...formy.getFieldProps('subscriptionPlan')}
            label="Тарифный план"
            options={Object.entries(ctx.appConfig.agentSubscriptionPlanMap).map(([key, agentSubscriptionPlanData]) => ({
              label: agentSubscriptionPlanData.label,
              value: agentSubscriptionPlanData.name,
            }))}
          />
          {formy.values.subscriptionPlan !== 'free' && (
            <>
              <Textfieldy
                label="Платная подписка истечёт через столько дней"
                {...formy.getFieldProps('paidSubscriptionPlanExpiresAfterDays')}
              />
            </>
          )}
          <Textfieldy
            label="Количество сгораемых токенов распознавания"
            {...formy.getFieldProps('temporaryRecognitionTokensCount')}
          />
          <Textfieldy
            label="Количество сгораемых токенов сценариев"
            {...formy.getFieldProps('temporaryScenarioTokensCount')}
          />
          <Buttons>
            <Button {...formy.buttonProps} type="submit">
              Создать
            </Button>
          </Buttons>
        </FormItems>
      </Segment>
    </Block>
  )
})
